module.exports = __webpack_public_path__ + "static/sf-ui-bold-2a419e5d90ab13ee251d5dca33db88c6.woff2";